<!-- Main Page Start -->
<section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="right-panel">

      <form>
          <h4 class="pageTitle"> Awards & Honors<a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn" (click)="openModal(addMore)" tooltip="addMore"><i class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add More </a></h4>

          <div class="education_added">
              <ul class="timeline">
                  <li *ngFor="let data of allData; let i =index"> 
                        <div *ngIf="data.isType == 1">
                            <span class="timeline-point-circle fill"></span>
                            <div class="el_details"> 
                                <p> <strong class="firstlCaptial">{{data.name || 'N/A'}} </strong> 
                                    <a href="javascript:void(0);" (click)="edit(data,addMore)"  title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                                    <a href="javascript:void(0);" (click)="delete(data.id)"  title="Delete"><img src="assets/images/ic_delete.svg" class="ht"> </a>
                                </p> 
                                <span> {{data.associatedWith}}</span>
                            </div>

                            <div class="el_details"> 
                                <ul>
                                    <!-- CGPA -->
                                <li *ngIf="data.issuesedOn"><span class="ft-wt"> Duration : </span> {{data.issuesedOn | date }}  </li>
                                <li *ngIf="!data.issuesedOn"><span class="ft-wt"> Duration : </span> N/A  </li>
                                <li><span class="ft-wt"> Project description :</span> {{data.description || 'N/A'}}</li>
                                </ul>
                            </div>
                        </div>
                  </li> 
              </ul>
          </div>

          <div class="form-group bottom ">
              <a href="javascript:void(0)" routerLink="/licenese" class="commonBtn width50 mt-5">Continue</a>
          </div>

      </form>
  </div>
</section>
<ng-template #addMore>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
        <form [formGroup]="form" (ngSubmit)="onSubmit()"> 
            <h4 class="pageTitle">{{title}} Awards & honors</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Title <span class="orangeText">*</span> </label>
                        <input type="text"  class="form-control upper" placeholder="Enter" formControlName="name" maxlength="50">
                        <div class="text-danger" *ngIf="form.controls['name'].hasError('required') && showError">
                            *Please enter title.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group">
                        <label>Associated with</label>
                        <input type="text"  class="form-control upper" placeholder="Enter" formControlName="associatedWith">
                        <div class="text-danger" *ngIf="form.controls['associatedWith'].hasError('required') && showError">
                            *Please enter associated with.
                        </div>
                    </div>
                </div>
               
  
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Issuer</label>
                        <input type="text"  class="form-control upper" placeholder="Enter" formControlName="issuer">
                        <div class="text-danger" *ngIf="form.controls['issuer'].hasError('required') && showError">
                            *Please enter issuer.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 "> 
                        <div class="form-group">
                            <label> Issue date</label>
                            <div id="date-picker-example" class="datepicker">
                              <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="form.value.issuesedOn" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="issuesedOn" [maxDate]="maxDate"(keydown)="onKeyDown($event)">
                              <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                          </div>
                          <div class="text-danger" *ngIf="showError == true && form.controls['issuesedOn'].hasError('required')">*Please select Issue date</div>
                        </div>                       
                </div>
                
                <div class="col-md-12 col-lg-12  col-sm-12">  
                    <div class="form-group">
                        <label>Description</label>
                        <textarea type="text" class="form-control" placeholder="The bachelor of commerce (BCom) will provide you with a broad foundation knowledge of contemporary business and its practices." formControlName="description" maxlength="250"></textarea>
                        <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                            *Please enter description.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['description'].hasError('minlength') && showError">
                            *Minimum length of 3 characters.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                            *Minimum length of 250 characters.
                        </div>
                    </div>
              </div>
            
              </div>                
  
            <div class="form-group ">
              <input type="submit" value="Save" class="commonBtn width50 mt-2"> 
            </div>
      
        </form>
    </div>
</ng-template>
